import {Icon, IconName} from 'components';
import {InteractiveChatAction} from 'types';

type ChatOptionInput = {
    id?: string;
    value: { name?: string; text: string; action: InteractiveChatAction };
};

const getInteractiveChatActionIcon = (action: InteractiveChatAction): IconName => {
    switch (action) {
        case InteractiveChatAction.SendMessage:
            return 'chat2';
        case InteractiveChatAction.CallAgent:
            return 'agent-participant';
        case InteractiveChatAction.Tree:
            return 'folders';
        case InteractiveChatAction.Reassign:
            return 'phone-forward';
        case InteractiveChatAction.Back:
            return 'corner-left-up';
        case InteractiveChatAction.RequestAppointment:
            return 'calendar';
        case InteractiveChatAction.ChatGpt:
            return 'chat-gpt';
        case InteractiveChatAction.Claude:
            return 'claude';
        case InteractiveChatAction.AsyncRequest:
            return 'shield';
        case InteractiveChatAction.Watsonx:
            return 'rocket'; // TODO: add icon
        case InteractiveChatAction.InternalLiveAgent:
            return 'agent-participant';
        case InteractiveChatAction.InteractiveChat:
            return 'external-link';
        default:
            return 'star';
    }
};

const buildInteractiveChatOption = ({id, value}: ChatOptionInput) => ({
    id,
    name: value.name || value.text,
    renderIcon: () => <Icon name={getInteractiveChatActionIcon(value.action)} />,
});

export const interactiveChatUtils = {
    getInteractiveChatActionIcon,
    buildInteractiveChatOption
};
